import React, {useEffect, useState} from "react";
import {Table} from "antd";
import Tabs from "antd/es/tabs";

import {withRouter} from 'react-router-dom';
import "rxpages/DashboardRxPage.scss";

import {connect} from "react-redux";
import {FormattedMessage, useIntl} from "react-intl";

import {displayNumberWithComma, formatExchangeRate} from 'utils/utils';

import CustomRxPageHeader from "rxcomponents/CustomRxPageHeader";

import {callGetCustomerTransactions, callGetMasterBalance, callGetVirtualAccountSubAccountBalance} from "rx/dashboard";

import {
    callAccountRippleBalance,
    callBankSubledgerBalance,
    countBeneVAOfCustomer,
    getFxRateRef
} from "../rx/dashboard/dashboardAction";
import LoadingIndicator from "../components/LoadingIndicator";

function DashboardRxPage(props) {
    const intl = useIntl();

    const [sourceToTargetHeader,setSourceToTargetHeader] = useState("");
    const [targetToSourceHeader,setTargetToSourceHeader] = useState("");
    const [feePerTransHeader,setFeePerTransHeader] = useState("");


    var data = [];
    useEffect(() => {
        props.callBeneVAOfCustomer();
        props.callGetCustomerTransactions();
        props.getFxRateRef(props.customer.customerTierName);
       // props.getFxRateRefRegular();
    }, []);
    useEffect(()=>{
        if(props.beneVAOfCustomer>0) {
            props.callGetVirtualAccountBalance();
        }else {
            props.callGetMasterBalance();
        }
    },[props.beneVAOfCustomer])

    // const getBalance = async () => {
    //     let counterVA = await props.callBeneVAOfCustomer();
    //     if(counterVA>0) {
    //         props.callGetVirtualAccountBalance();
    //     }else {
    //         props.callGetMasterBalance();
    //         // props.callAccountRippleBalance();
    //         // props.callBankSubledgerBalance();
    //     }
    // }

    let masterCustomerBalances = [
        {
          title: intl.formatMessage({id: "app.page.dashboardrxpage.currency"}),
          // width: 60,
          dataIndex: "currency",
          key: "currency"
        },
        {
            title: intl.formatMessage({id: "app.page.dashboardrxpage.availablebalance"}),
            // width: 100,
            dataIndex: "balance",
            key: "balance",
            render: (text, record) => (
                <span>{displayNumberWithComma(text, 2)}</span>
            )
        },
        /*{
            title: intl.formatMessage({id: "app.page.dashboardrxpage.masterBalance"}),
            width: 100,
            dataIndex: "masterBalance",
            key: "masterBalance",
            render: (text, record) => {
                var totalBalance = record.balance ? record.balance : 0;
                var bankSubledgerBalance = record.bankSubledgerBalance ? record.bankSubledgerBalance : 0;
                var masterBalance = totalBalance - bankSubledgerBalance;
                return <>{displayNumberWithComma(masterBalance)}</>
            }
        },
        {
            title: intl.formatMessage({id: "app.page.dashboardrxpage.bank.subledger.balance"}),
            dataIndex: 'bankSubledgerBalance',
            key: 'bankSubledgerBalance',
            width: 100,
            render: (text, record) => (
                <>{text ? displayNumberWithComma(text) : 0.00.toFixed(2)}</>
            )
        },
        {
            title: intl.formatMessage({id: "app.page.dashboardrxpage.rippleBalance"}),
            width: 100,
            dataIndex: "rippleBalance",
            key: "rippleBalance",
            render: rippleBalance => {
                if (rippleBalance) {
                    return <>{rippleBalance ? displayNumberWithComma(rippleBalance) : 0.00.toFixed(2)}</>
                } else {
                    return 'NA'
                }
            }
        }
*/
      ];
    let virtualAccountBalanceColumns = [
        {
            title: intl.formatMessage({id: "app.page.dashboardrxpage.virtualaccountlocation"}),
            width: 120,
            dataIndex: "virtualAccountChannelCode",
            key: "virtualAccountChannelCode",
            render: (text, record) => {
                var location = '';
                if (text == 'DBS_HK' ) {
                    location = "Hong Kong"
                } else if (text == 'DBS_SG') {
                    location = "Singapore"
                } else if (text == 'SAHABAT_SAMPOERNA') {
                    location = "Indonesia"
                } else if (text == 'FLASH_FX') {
                    location = "Australia"
                } else {
                    location = record.bankSubledgerCountry
                }
                return <span>{location}</span>
            }
        },
        {
            title: intl.formatMessage({id: "app.page.dashboardrxpage.virtualaccountnumber"}),
            width: 200,
            dataIndex: "subAccountReference",
            key: "subAccountReference",
            render: (text, record) => {
                var vaNumber = '-';
                if (record.subledgerType == 'VIRTUAL_ACCOUNT' ) {
                    vaNumber = text
                }
                return <span>{vaNumber}</span>
            }
        },
        {
            title: intl.formatMessage({id: "app.page.dashboardrxpage.accountname"}),
            width: 200,
            dataIndex: "virtualAccountName",
            key: "virtualAccountName",
            render: (text, record) => {
                var accountName = '-';
                if (record.subledgerType == 'VIRTUAL_ACCOUNT' ) {
                    accountName = text
                } else {
                    accountName = record.bankSubledgerName
                }
                return <span>{accountName}</span>
            }
        },
        {
          title: intl.formatMessage({id: "app.page.dashboardrxpage.currency"}),
          width: 60,
          dataIndex: "currency",
          key: "currency"
        },
        {
            title: intl.formatMessage({id: "app.page.dashboardrxpage.balanceonhold"}),
            width: 100,
            dataIndex: "balance",
            key: "balance",
            render: (text, record) => (
                <span>{displayNumberWithComma(text, 2)}</span>
            )
        },
        {
            title: intl.formatMessage({id: "app.page.dashboardrxpage.claimedbalance"}),
            width: 100,
            dataIndex: "claimedBalance",
            key: "claimedBalance",
            render: (text, record) => (
                <span>{displayNumberWithComma(text, 2)}</span>
            )
        }
      ];

      let customerTransationsColumns = null;
      if (props.customer.approval) {
        customerTransationsColumns = [
            {
                title: intl.formatMessage({id: "app.page.dashboardrxpage.sourcecurrency"}),
                width: 60,
                dataIndex: "sourceCurrency",
                key: "sourceCurrency"
            },
            {
                title: "Pending Approval",
                width: 120,
                dataIndex: "pendingApprovalAmount",
                key: "pendingApprovalAmount",
                render: (text, record) => (
                    <span>{displayNumberWithComma(text, 2)} <span style={{marginLeft: "3px"}}>{record.pendingApprovalCount > 0 ? '['+record.pendingApprovalCount+']' : ''}</span></span>
                )
            },
            {
                title: "Pending Authorize",
                width: 120,
                dataIndex: "pendingAuthorizeAmount",
                key: "pendingAuthorizeAmount",
                render: (text, record) => (
                    <span>{displayNumberWithComma(text, 2)} <span style={{marginLeft: "3px"}}>{record.pendingAuthorizeCount > 0 ? '['+record.pendingAuthorizeCount+']' : ''}</span></span>
                )
            },
            {
                title: "Booking",
                width: 120,
                dataIndex: "bookingAmount",
                key: "bookingAmount",
                render: (text, record) => {
                    var amount = record.bookingAmount + record.complianceAmount;
                    var count = record.bookingCount + record.complianceCount;
                    return <span>{displayNumberWithComma(amount, 2)} <span style={{marginLeft: "3px"}}>{count > 0 ? '['+count+']' : ''}</span></span>
                }
            },
            {
                title: "Received",
                width: 120,
                dataIndex: "receivedAmount",
                key: "receivedAmount",
                render: (text, record) => (
                    <span>{displayNumberWithComma(text, 2)} <span style={{marginLeft: "3px"}}>{record.receivedCount > 0 ? '['+record.receivedCount+']' : ''}</span></span>
                )
            },
            {
                title: "Processing",
                width: 120,
                dataIndex: "sentAmount",
                key: "sentAmount",
                render: (text, record) => (
                    <span>{displayNumberWithComma(text, 2)} <span style={{marginLeft: "3px"}}>{record.sentCount > 0 ? '['+record.sentCount+']' : ''}</span></span>
                )
            },
            {
                title: "Completed",
                width: 120,
                dataIndex: "completedAmount",
                key: "completedAmount",
                render: (text, record) => (
                    <span>{displayNumberWithComma(text, 2)} <span style={{marginLeft: "3px"}}>{record.completedCount > 0 ? '['+record.completedCount+']' : ''}</span></span>
                )
            }
          ];
      } else {
        customerTransationsColumns = [
            {
                title: intl.formatMessage({id: "app.page.dashboardrxpage.sourcecurrency"}),
                width: 60,
                dataIndex: "sourceCurrency",
                key: "sourceCurrency"
            },
            {
                title: "Booking",
                width: 120,
                dataIndex: "bookingAmount",
                key: "bookingAmount",
                render: (text, record) => {
                    var amount = record.bookingAmount + record.complianceAmount;
                    var count = record.bookingCount + record.complianceCount;
                    return <span>{displayNumberWithComma(amount, 2)} <span style={{marginLeft: "3px"}}>{count > 0 ? '['+count+']' : ''}</span></span>
                }
            },
            {
                title: "Received",
                width: 120,
                dataIndex: "receivedAmount",
                key: "receivedAmount",
                render: (text, record) => (
                    <span>{displayNumberWithComma(text, 2)} <span style={{marginLeft: "3px"}}>{record.receivedCount > 0 ? '['+record.receivedCount+']' : ''}</span></span>
                )
            },
            {
                title: "Processing",
                width: 120,
                dataIndex: "sentAmount",
                key: "sentAmount",
                render: (text, record) => (
                    <span>{displayNumberWithComma(text, 2)} <span style={{marginLeft: "3px"}}>{record.sentCount > 0 ? '['+record.sentCount+']' : ''}</span></span>
                )
            },
            {
                title: "Completed",
                width: 120,
                dataIndex: "completedAmount",
                key: "completedAmount",
                render: (text, record) => (
                    <span>{displayNumberWithComma(text, 2)} <span style={{marginLeft: "3px"}}>{record.completedCount > 0 ? '['+record.completedCount+']' : ''}</span></span>
                )
            }
          ];
      }

    const buildFxRateRef = (fxRateRef) => {

        if (fxRateRef && fxRateRef[0]) {

            let sourceCurrency = fxRateRef[0].sourceCurrency;
           // let targetCurrency = props.fxRateRef['SGD'][0].targetCurrency;
            const fxRateRefColumns = [
                {
                    title: intl.formatMessage({id: "app.common.currencyfcy"}),
                    width: 60,
                    dataIndex: "targetCurrency",
                    key: "targetCurrency"
                },
                {
                    title: 'Condition',
                    width: 60,
                    dataIndex: "condition",
                    key: "condition"
                },
                {
                    title: `1 ${sourceCurrency} ${intl.formatMessage({id: "app.common.to"})} FCY`,
                    width: 100,
                    dataIndex: "sourceToTargetRate",
                    key: "sourceToTargetRate",
                    render: (text, record) => (
                        <span>{formatExchangeRate(text, 4)}</span>
                    )
                },
                {
                    title: `1 FCY ${intl.formatMessage({id: "app.common.to"})} ${sourceCurrency}`,
                    width: 100,
                    dataIndex: "targetToSourceRate",
                    key: "targetToSourceRate",
                    render: (text, record) => (
                        <span>{formatExchangeRate(text, 4)}</span>
                    )
                },
                {
                    title: `${intl.formatMessage({id: "app.common.ratetype"})}`,
                    width: 100,
                    dataIndex: "rateType",
                    key: "rateType"

                },
                /*
                {
                    title: `${intl.formatMessage({id: "app.page.dashboardrxpage.fee.per.transaction"})}`,
                    width: 60,
                    dataIndex: "feePerTransaction",
                    key: "feePerTransaction",
                    render: (text, record) => (
                        <span>{displayNumberWithComma(text, 2)} <b>{record.feeCurrency}</b></span>
                    )
                },
                */
            ]

            return (
                <>
                    <div>
                        <br/>
                        <h4 className="bp-page-headline">
                            {fxRateRef[0].sourceCurrency} <FormattedMessage id="app.page.dashboardrxpage.rate.reference"/>
                        </h4>
                        <Table
                            expandIconAsCell={false}
                            expandIconColumnIndex={-1}
                            className="bp-table"
                            columns={fxRateRefColumns}
                            dataSource={fxRateRef}
                            rowKey="id"
                            pagination={false}
                        />
                    </div>
                </>
            )
        } else {
          return (<> </>);
     }
    }

      const buildTheFirstTab = () =>{
          if(props.beneVAOfCustomer > 0){
              return (
                  <Tabs.TabPane tab={intl.formatMessage({id: "app.page.dashboardrxpage.virtualaccountbalance"})} key="1">
                      <div className="bp-page-content bp-page-large">
                          <br/>
                          <Table
                              expandIconAsCell={false}
                              expandIconColumnIndex={-1}
                              className="bp-table"
                              columns={virtualAccountBalanceColumns}
                              dataSource={props.virtualAccountSubAccountBalance}
                              rowKey="id"
                              pagination={false}
                          />
                      </div>
                  </Tabs.TabPane>
              );
          }

          let data = Object
              .entries(props.masterBalance)
              .map(([currency, balance], id) => ({ currency, balance, id }));
          for (let item in data) {
              if(props.bankSubledgerBalance) {
                  data[item].bankSubledgerBalance = props.bankSubledgerBalance[data[item].currency];
              }
              if(props.rippleBalance) {
                  let currencyHasBalance = props.rippleBalance.filter(s => {
                      return s.currency === data[item].currency
                  });
                  if (currencyHasBalance.length > 0) {
                      data[item].rippleBalance = displayNumberWithComma(currencyHasBalance[0].balance);
                  }
              }
          }

          return (
              <Tabs.TabPane tab={intl.formatMessage({id: "app.page.dashboardrxpage.virtualaccountbalance"})} key="1">
                  <div className="bp-page-content bp-page-large">
                      <br/>
                      <Table
                          expandIconAsCell={false}
                          expandIconColumnIndex={-1}
                          className="bp-table"
                          columns={masterCustomerBalances}
                          dataSource={data}
                          rowKey="id"
                          pagination={false}
                      />
                  </div>
              </Tabs.TabPane>
          );
      }

    return (
        <div>
            <CustomRxPageHeader customer={props.customer}
                title={intl.formatMessage({id: "app.sidebar.dashboard"})} />
            <Tabs defaultActiveKey="1" >
                {buildTheFirstTab()}
            <Tabs.TabPane tab={intl.formatMessage({id: "app.page.dashboardrxpage.orderstatus"})} key="2">
                <div className="bp-page-content bp-page-large">
                    <br/>
                    {
                        props.loading ? <LoadingIndicator/> :
                            <Table
                                expandIconAsCell={false}
                                expandIconColumnIndex={-1}
                                className="bp-table"
                                columns={customerTransationsColumns}
                                dataSource={props.customerTransactions}
                                rowKey="id"
                                pagination={false}
                            />
                    }

                </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab={intl.formatMessage({id: "app.page.dashboardrxpage.fx.rate.reference"})} key="3">
                <div className="bp-page-content bp-page-large">
                {Object.keys(props.fxRateRef).map((key, i) => {
                    return ( buildFxRateRef(props.fxRateRef[key]))
                })}
                </div>
            </Tabs.TabPane>    
            </Tabs>
            
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        masterBalance: state.dashboard.masterBalance,
        virtualAccountSubAccountBalance: state.dashboard.virtualAccountSubAccountBalance,
        customerTransactions: state.dashboard.customerTransactions,
        fxRateRef: state.dashboard.fxRateRef,
        beneVAOfCustomer: state.dashboard.countBeneVAOfCustomer,
        bankSubledgerBalance: state.dashboard.bankSubledgerBalance,
        rippleBalance: state.dashboard.rippleBalance,
        loading: state.dashboard.loading,
    };
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        callBeneVAOfCustomer: () => dispatch(countBeneVAOfCustomer()),
        callGetMasterBalance: () => dispatch(callGetMasterBalance()),
        // callAccountRippleBalance: () => dispatch(callAccountRippleBalance()),
        // callBankSubledgerBalance: ()=> dispatch(callBankSubledgerBalance()),
        callGetVirtualAccountBalance: () => dispatch(callGetVirtualAccountSubAccountBalance()),
        callGetCustomerTransactions: () => dispatch(callGetCustomerTransactions()),
        getFxRateRef: (customerTierName) => dispatch(getFxRateRef(customerTierName)),
       // getFxRateRefRegular: () => dispatch(getFxRateRefRegular()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(DashboardRxPage));